
import React from "react";
import "./index.css"

export default class extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            deviceType: "",
            questionnaireList: [],
            formList: [],
            isSuccess: false
        }
    }

    componentDidMount() {
        document.body.style.background = "transparent"
    }

    render() {
        return <div className="tvDownload">
            <div className="content">
                <div className="item"></div>
                <div className="item">
                    <img className="qrcode" src={require("../../static/images/download-svmeet.png").default} alt=""></img>
                </div>
                <div className="item">
                    <div className="browser">Chrome / Firefox / Safari</div>
                </div>
            </div>
        </div>
    }
}